import React, { useEffect, useMemo } from 'react';
import './VinculacioView.css';
import { CALLBACK_URL } from '../config';
import ThemedButton from './ThemedButton';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

declare global {
  interface Window {
    ACCESS_TOKEN?: string;
  }
}

const VinculacioView: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [params] = useSearchParams();

  useEffect(() => {
    const language = params.get('lang');
    language && i18n.changeLanguage(language);
  }, [params]);

  window.addEventListener('access_token_injected', () => {
    localStorage.setItem('access_token', window?.ACCESS_TOKEN as string);
  });

  const handleStartClick = () => {
    window.location.href = `https://valid-pre.aoc.cat/o/oauth2/auth?scope=autenticacio_usuari&redirect_uri=${CALLBACK_URL}&response_type=code&client_id=wallet&approval_prompt=auto&lang=${i18n.language}`;
  };

  return (
    <div className="vinculacio-container">
      <div className="vinculacio-content">
        <img
          src="/images/logoLanding.png"
          alt="idCAT Logo"
          className="vinculacio-logo"
        />
        <h1 className="vinculacio-title">{t('vinculacioPage.header')}</h1>
        <p className="vinculacio-description">
          {t('vinculacioPage.description')}
        </p>
        <img
          src="images/person.svg"
          alt="Person Illustration"
          className="link-view-image"
        />
        <div className="link-button-container">
          <ThemedButton
            text={t('vinculacioPage.button')}
            onClick={handleStartClick}
          />
        </div>
      </div>
    </div>
  );
};

export default VinculacioView;
